import React, {useState,useRef,useContext} from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Button, Input, Space, Table, Modal,Form,Select ,Radio,DatePicker,InputNumber ,Popconfirm } from 'antd'

import { SearchOutlined } from '@ant-design/icons';
import {css} from '@emotion/css'
import { AuthContext } from '../helpers/AuthContex';

import './PatientList.css'
import "antd/dist/reset.css";

import dayjs from 'dayjs';
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");

dayjs.extend(utc);
dayjs.extend(timezone);
const bangkokTimezone = "Asia/Bangkok"

const SubmitButton = ({ form, handleModalCancel, setListOfEmployee, department_id,setLoading}) => {
  const [submittable, setSubmittable] = React.useState(false);

  const values = Form.useWatch([], form);

  const handleClick = async() =>{
    setLoading(true)
    const response = await axios.post(process.env.REACT_APP_API_URL + `/employee`,{...values,status:"active"},{ headers:{accessToken: Cookies.get('accessToken'),}})
    const employee = await axios.get(process.env.REACT_APP_API_URL + `/employee`,{ headers:{accessToken: Cookies.get('accessToken'),}})
    if(department_id !== 0 )
        {
          const filtersEmployee = employee.data.filter(item => item.department_id === department_id )
          setListOfEmployee(filtersEmployee)
        }
        else
        {
          setListOfEmployee(employee.data)
        }
    handleModalCancel();
    setLoading(false)
  }

  React.useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        },
      );
  }, [values]);

  return (
    <Button type="primary" htmlType="submit" disabled={!submittable} onClick={handleClick} className='bg-[#1677FF]'>
      ตกลง
    </Button>
  );
};

const SubmitButton2 = ({form, setListOfEmployee,handleEditModalCancel,setLoading}) => {
  const [submittable, setSubmittable] = React.useState(false);

  const values = Form.useWatch([], form);

  const handleClick = async() =>{
    setLoading(true)
    const response = await axios.put(process.env.REACT_APP_API_URL + `/employee/${values.id}`,{...values,status:"active"},{ headers:{accessToken: Cookies.get('accessToken'),}})
    const employee = await axios.get(process.env.REACT_APP_API_URL + `/employee`,{ headers:{accessToken: Cookies.get('accessToken'),}})
    setListOfEmployee(employee.data)
    handleEditModalCancel();
    setLoading(false)
    
  }

  React.useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        },
      );
  }, [values]);

  return (
    <Button type="primary" htmlType="submit" disabled={!submittable} onClick={handleClick} className='bg-[#1677FF]'>
      ตกลง
    </Button>
  );
};



const EmployeeListcom = ({setLoading,setListOfEmployee,employee, setSelectedemployee,clinic }) => {

  const {authState} = useContext(AuthContext)
  const [isModalopen, setIsmodalOpen] = useState(false)
  const [isModalEditOpen, setIsModalEditOpen] = useState(false)
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [isModalCommissionOpen, setIsModalComissionOpen] = useState(false)
  const searchInput = useRef(null);
  const option = clinic.map(item=> ({value:item.id, label:item.department}))
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [commissionForm] = Form.useForm();
  const commissionType = Form.useWatch('commissionType', commissionForm);

  const roleOptions = [{value:'ผู้จัดการสาขา',label:'ผู้จัดการสาขา'},{value:'นักกายภาพบำบัด',label:'นักกายภาพบำบัด'},{value:'ผู้ช่วยนักกายภาพบำบัด',label:'ผู้ช่วยนักกายภาพบำบัด'}]

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`ค้าหา ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            className='bg-[#7877FF]'
            style={{
              width: 90,
            }}
            type="primary"
          >
            Search
            
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>

        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  
  const handleRowEdit = (record) => {
    setIsModalEditOpen(true);
    form2.setFieldsValue({
      id: record.id,
      name: record.name,
      nickname: record.nickname,
      age: record.age,
      role: record.role,
      status: record.status,
      department_id: record.department_id,
      handfee:record.handfee,
      pms_fee: record.pms_fee,
    });
  };

  const handleCommission = () => {
    setIsModalComissionOpen(true);
  };

  const handleRowDelete = async (key) =>{
    const department_id = authState.department_id
    setLoading(true)
    const data ={
      employee_id : parseInt(key.id)
    }
    const response = await axios.put(process.env.REACT_APP_API_URL+`/employee/disable-employee`,data,{ headers:{accessToken: Cookies.get('accessToken'),}}) 
    const employee = await axios.get(process.env.REACT_APP_API_URL + `/employee`,{ headers:{accessToken: Cookies.get('accessToken'),}})
    if(department_id !== 0 )
        {
          const filtersEmployee = employee.data.filter(item => item.department_id === department_id )
          setListOfEmployee(filtersEmployee)
        }
        else
        {
          setListOfEmployee(employee.data)
        }
    setLoading(false)
  }

  const columns = [
    {
      title: 'รหัสพนักงาน',
      dataIndex: 'id',
      key: 'id',
      ...getColumnSearchProps('id'),
    },
    {
        title: 'ชื่อพนักงาน',
        dataIndex: 'name',
        key: 'name',
        ...getColumnSearchProps('name'),
      },
      {
        title: 'ชื่อเล่น',
        dataIndex: 'nickname',
        key: 'nickname',
        ...getColumnSearchProps('nickname'),
      },
      {
        title: 'ต่ำแหน่ง',
        dataIndex: 'role',
        key: 'role',
      },
      {
        title: 'สถานะ',
        dataIndex: 'status',
        key: 'status',
      },
      {
        title: 'ค่าหัต',
        dataIndex:'handfee',
        key:'handfee',
      },
      {
        title: 'รหัสสาขา',
        dataIndex: 'department_id',
        key: 'department_id',
      },
      {
        title: 'จัดการ',
        dataIndex: 'operation',
        render: (_, record) =>
        {return (
          <Space>
              <button onClick={()=>{handleRowEdit(record)}}  className=' text-blue-400 font-bold'>แก้ไข</button>
              <Popconfirm
                title="ลบพนักงาน"
                description="คุณกำลังลบพนักงาน กรุณาตรวจสอบความถูกต้อง"
                onConfirm={()=>{handleRowDelete(record)}}
                okText="ตกลง"
                cancelText="ยกเลิก"
                okButtonProps={{ style: { backgroundColor: '#1677ff', color: 'white' } }} 
              >
                <button className=' text-blue-400 font-bold hover:cursor-pointer'>ลบ</button>
              </Popconfirm>
          </Space>
        )}
        ,
        width:"10%",
        align:"center"
      },
  ];
  

  const test = (t) => {
    setSelectedemployee(t)
  }
  
  const handleModalCancel =() =>
  {
    form.resetFields();
    setIsmodalOpen(false)
  }

  const handleEditModalCancel =() =>{
    setIsModalEditOpen(false)
  }

  const handleComissionModalCancel =() =>{
    commissionForm.resetFields();
    setIsModalComissionOpen(false)
  }

  const handleComissionModalSubmit = async (value) =>{
    setLoading(true)
    const employee = await axios.post(process.env.REACT_APP_API_URL + `/comission/adjust-commission`,value,{ headers:{accessToken: Cookies.get('accessToken'),}})
    handleComissionModalCancel();
    setLoading(false)
  }

  const tableCSS = css({
    backgroundColor: 'white',
    '& table': {
      borderCollapse: 'collapse'
    },
    '& thead > tr': {
      borderWidth: '1px',
      borderColor: 'black',
      borderStyle: 'solid',
      backgroundColor: "blue"
    },
    '.ant-table-thead .ant-table-cell':
    {
      backgroundColor: '#00BA9E',
      color: 'white',
      borderRadius: 'unset !important'
    }
    
  });

  





    return (
        <>
        
        <div className='md:p-[24px]  md:bg-[#E77B7C] md:shadow-2xl md:mx-[10rem] mx-[0.5rem] rounded-xl ' >
          <div className={`md:px-[24px] px-[0.5rem] pt-[24px] bg-white shadow-2xl rounded-xl ${(employee?.length === 0 ) ? 'pb-[24px]' : null}`}>
        <Table
            columns={columns}
            dataSource={employee}
            rowKey="id" 
            onRow={(record, rowIndex) => {
              return {
                onClick: event => {test(record)}, 
            }}}
            size="small"
            className={tableCSS}
            scroll={{x:'max-content'}}
        />
        </div>
        </div>
        <Button className='bg-white m-5' onClick={()=>{setIsmodalOpen(true)}}>เพิ่มพนักงาน</Button>
        <Button className='bg-white m-5' onClick={()=>{setIsModalComissionOpen(true)}}>จัดการค่า Commission</Button>



        <Modal width={1000} title="เพิ่มพนักงาน" open={isModalopen}  onCancel={handleModalCancel} footer={false}> 
            <Form form={form} name="validateOnly" layout="vertical" autoComplete="off">
              <Form.Item
                name="name"
                label="ชื่อพนักงาน"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                  name="age"
                  label="อายุ"
                  rules={[
                    {
                      required: true,
                      message: 'กรุณากรอกอายุ',
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: 'อายุต้องอยู่ในช่วง 0-100 ปี',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                name="handfee"
                label="ค่ามือ/หัตถการ"
                rules={[
                  {
                    required: true,
                    message: 'กรุณากรอกค่ามือ/หัตถการ',
                  },
                  {
                    pattern: /^[0-9]+$/,
                    message: 'ค่ามือ/หัตถการต้องอยู่ในช่วง 0-100',
                  },
                ]}
              >
                <Input />
                </Form.Item>
                <Form.Item
                name="pms_fee"
                label="ค่า PMS"
                rules={[
                  {
                    pattern: /^[0-9]*$/,
                    message: 'ค่า PMS ต้องเป็นตัวเลข',
                  },
                ]}
              >
                <Input placeholder="ไม่บังคับ" />
                </Form.Item>
                <Form.Item
                name="nickname"
                label="ชื่อเล่น"
                rules={[
                  {
                    required: true,
                  },
                ]}
                >
                <Input />

                </Form.Item>
                <Form.Item
                name="role"
                label="ตำแหน่ง"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="ตำแหน่ง" options={roleOptions} />
              </Form.Item>
              <Form.Item
                name="department_id"
                label="ประจำสาขา"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="ประจำสาขา" options={option} />
              </Form.Item>


              
              <Form.Item>
                <Space>
                  <SubmitButton form={form} handleModalCancel={handleModalCancel} setListOfEmployee={setListOfEmployee}  department_id={authState.department_id} setLoading={setLoading}/>
                  <Button htmlType="reset" onClick={handleModalCancel}>ยกเลิก</Button>
                </Space>
              </Form.Item>
            </Form>
        </Modal>




        <Modal width={1000} title="แก้ไขพนักงาน" open={isModalEditOpen}  onCancel={handleEditModalCancel} footer={false}> 
            <Form form={form2} name="validateOnly" layout="vertical" autoComplete="off">
              <Form.Item
                name="id"  
                label="รหัสพนักงาน" 
                >
              <Input readOnly /> 
              </Form.Item>
              <Form.Item
                name="name"
                label="ชื่อพนักงาน"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="nickname"
                label="ชื่อเล่นพนักงาน"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                  name="age"
                  label="อายุ"
                  rules={[
                    {
                      required: true,
                      message: 'กรุณากรอกอายุ',
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: 'อายุต้องอยู่ในช่วง 0-100 ปี',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                name="handfee"
                label="ค่ามือ/หัตถการ"
                rules={[
                  {
                    required: true,
                    message: 'กรุณากรอกค่าหัต',
                  },
                  {
                    pattern: /^[0-9]+$/,
                    message: 'ค่าหัตต้องอยู่ในช่วง 0-100',
                  },
                ]}
              >
                <Input />
                </Form.Item>
                <Form.Item
                name="pms_fee"
                label="ค่า PMS"
                rules={[
                  {
                    pattern: /^[0-9]*$/,
                    message: 'ค่า PMS ต้องเป็นตัวเลข',
                  },
                ]}
              >
                <Input placeholder="ไม่บังคับ" />
                </Form.Item>
                <Form.Item
                name="role"
                label="ตำแหน่ง"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="ตำแหน่ง" options={roleOptions} />
              </Form.Item>
              <Form.Item
                name="department_id"
                label="ประจำสาขา"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select placeholder="Select" options={option} />
              </Form.Item>


              
              <Form.Item>
                <Space>
                  <SubmitButton2 form={form2} handleModalCancel={handleEditModalCancel} setListOfEmployee={setListOfEmployee} handleEditModalCancel={handleEditModalCancel} setLoading={setLoading}/>
                  <Button htmlType="reset" onClick={handleEditModalCancel}>ยกเลิก</Button>
                </Space>
              </Form.Item>
            </Form>
        </Modal>

        <Modal  title="จัดการค่า Commission" open={isModalCommissionOpen}  onCancel={handleComissionModalCancel} footer={false}> 
            <Form  form={commissionForm} name="validateOnly"  autoComplete="off" onFinish={handleComissionModalSubmit}>
            <Form.Item name="date" label="วันที่" rules={[{ required: true, message: 'กรุณากรอกวันที่'  }]}>
                <DatePicker 
                  disabledDate={(current) => current && current > dayjs().endOf('day')}
                />
              </Form.Item>
              <Form.Item name="commissionType" label="ประเภทการจัดการ" rules={[{ required: true, message: 'กรุณากรอกประเภทการจัดการ'  }]}>
                <Radio.Group>
                  <Radio value="ค่ามือ">จัดการค่ามือ</Radio>
                  <Radio value="ค่าแนะนำ">จัดการค่าแนะนำ</Radio>
                </Radio.Group>
              </Form.Item>
              {commissionType === "ค่าแนะนำ" && (
                <Form.Item name="commissionPercent" label="เปอร์เซ็นค่าแนะนำ" rules={[{ required: true, message: 'กรุณาเลือกประเภทการแนะนำ' }]}>
                  <Radio.Group>
                    <Radio value={1}>1%</Radio>
                    <Radio value={2}>2%</Radio>
                    <Radio value={3}>3%</Radio>
                    <Radio value={4}>4%</Radio>
                  </Radio.Group>
                </Form.Item>
              )}
              <Form.Item name="operationType" label="ประเภทการดำเนินการ" rules={[{ required: true , message: 'กรุณากรอกประเภทการดำเนินการ' }]}>
                <Radio.Group>
                  <Radio value="เพิ่ม">เพิ่ม</Radio>
                  <Radio value="ลด">ลด</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="amount"
                label="จำนวน"
                rules={[
                  { required: true, message: 'กรุณากรอกตัวเลข' },
                  { type: 'number', min: 0, message: 'ตัวเลขต้องมากกว่า 0' }
                ]}
              >
                <InputNumber placeholder="จำนวน"/>
              </Form.Item>
              <Form.Item
                name="employee"
                label="เลือกพนักงาน"
                rules={[{ required: true, message: 'กรุณากรอกจำนวน'  }]}
              >
                <Select
                  showSearch
                  placeholder="ค้นหาพนักงาน"
                  options={employee.map(emp => ({ value: emp.id, label: emp.name }))}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase()) ||
                    option.value.toString().toLowerCase().includes(input.toLowerCase())
                  }/>
              </Form.Item>
              <Form.Item>
                <Space>
                  <Button htmlType="submit" >
                  ตกลง
                  </Button>
                  <Button htmlType="reset" onClick={handleComissionModalCancel}>ยกเลิก</Button>
                </Space>
              </Form.Item>
            </Form>
        </Modal>


    


        </>
    );
    }

export default EmployeeListcom